import { Tag } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { ContractStatusDto } from "../../autogen/bff-api";

interface Props {
  status: ContractStatusDto;
  size?: "sm" | "md" | "lg";
}

export const ContractStatusTag = ({ status, size }: Props) => {
  const { t } = useTranslation();
  const tagMeta = { color: CONTRACT_STATUS_COLORS[status], text: contractStatusLabel(status, t) };

  return (
    <Tag
      variant="outline"
      colorScheme={tagMeta.color}
      size={size}
      textAlign="center"
      paddingTop={"2px"}
      paddingBottom={"2px"}
    >
      {tagMeta.text}
    </Tag>
  );
};

const CONTRACT_STATUS_COLORS: Record<ContractStatusDto, string> = {
  [ContractStatusDto.Awarded]: "purple",
  [ContractStatusDto.Active]: "green",
  [ContractStatusDto.Expired]: "orange",
  [ContractStatusDto.Terminated]: "red",
};

export const contractStatusLabel = (status: ContractStatusDto, t: (key: string) => string): string => {
  switch (status) {
    case ContractStatusDto.Awarded:
      return t("Awarded");
    case ContractStatusDto.Active:
      return t("Active");
    case ContractStatusDto.Expired:
      return t("Expired");
    case ContractStatusDto.Terminated:
      return t("Terminated");
  }
};
